// userApiSlice.js
import { apiSlice } from "../../api/apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserConfigure: builder.query({
      query: () => ({
        url: "/user/configure",
        method: "GET",
      }),
      providesTags: ["User"],
    }),
    updateUserConfigure: builder.mutation({
      query: (data) => ({
        url: "/user/configure",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const { useGetUserConfigureQuery, useUpdateUserConfigureMutation } =
  userApiSlice;
